/*
 * third-party-a11y-shim.js
 * Bolts accessible names onto third-party widgets we can't edit at the source:
 *  - Judge.me carousel arrow buttons (.jdgm-arrow) get aria-labels
 *  - Google Merchant trust badge iframe (#merchantwidgetiframe) gets a title
 *
 * The widgets render after page load and may re-render on interaction, so we
 * run the shim on DOMContentLoaded AND watch the DOM for additions.
 */
(function () {
  if (window.__yxeA11yShimWired) return;
  window.__yxeA11yShimWired = true;

  function labelJudgemeArrows(root) {
    var arrows = (root || document).querySelectorAll('.jdgm-arrow:not([aria-label])');
    arrows.forEach(function (btn) {
      var isPrev = btn.classList.contains('jdgm-prev') || btn.classList.contains('jdgm-arrow--prev');
      btn.setAttribute('aria-label', isPrev ? 'Previous review' : 'Next review');
    });
  }

  function labelMerchantIframe(root) {
    var frame = (root || document).querySelector('#merchantwidgetiframe:not([title])');
    if (frame) frame.setAttribute('title', 'Google customer reviews');
  }

  function run(root) {
    labelJudgemeArrows(root);
    labelMerchantIframe(root);
  }

  function init() {
    run(document);
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) run(added[j]);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
